// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as VillagepandoRouteImport } from './routes/villagepando'
import { Route as VisionRouteImport } from './routes/vision'
import { Route as WhitepaperRouteImport } from './routes/whitepaper'
import { Route as AdminAnalyticsRouteImport } from './routes/admin.analytics'
import { Route as AdminAuditRouteImport } from './routes/admin.audit'
import { Route as AdminFunnelRouteImport } from './routes/admin.funnel'
import { Route as AdminHealthRouteImport } from './routes/admin.health'
import { Route as AdminMessagesRouteImport } from './routes/admin.messages'
import { Route as AdminReliabilityRouteImport } from './routes/admin.reliability'
import { Route as AdminSalesRouteImport } from './routes/admin.sales'
import { Route as VillagepandoAssetRouteImport } from './routes/villagepando.$asset'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const VillagepandoRoute = VillagepandoRouteImport.update({
            id: '/villagepando',path: '/villagepando',getParentRoute: () => rootRouteImport
          })
const VisionRoute = VisionRouteImport.update({
            id: '/vision',path: '/vision',getParentRoute: () => rootRouteImport
          })
const WhitepaperRoute = WhitepaperRouteImport.update({
            id: '/whitepaper',path: '/whitepaper',getParentRoute: () => rootRouteImport
          })
const AdminAnalyticsRoute = AdminAnalyticsRouteImport.update({
            id: '/admin/analytics',path: '/admin/analytics',getParentRoute: () => rootRouteImport
          })
const AdminAuditRoute = AdminAuditRouteImport.update({
            id: '/admin/audit',path: '/admin/audit',getParentRoute: () => rootRouteImport
          })
const AdminFunnelRoute = AdminFunnelRouteImport.update({
            id: '/admin/funnel',path: '/admin/funnel',getParentRoute: () => rootRouteImport
          })
const AdminHealthRoute = AdminHealthRouteImport.update({
            id: '/admin/health',path: '/admin/health',getParentRoute: () => rootRouteImport
          })
const AdminMessagesRoute = AdminMessagesRouteImport.update({
            id: '/admin/messages',path: '/admin/messages',getParentRoute: () => rootRouteImport
          })
const AdminReliabilityRoute = AdminReliabilityRouteImport.update({
            id: '/admin/reliability',path: '/admin/reliability',getParentRoute: () => rootRouteImport
          })
const AdminSalesRoute = AdminSalesRouteImport.update({
            id: '/admin/sales',path: '/admin/sales',getParentRoute: () => rootRouteImport
          })
const VillagepandoAssetRoute = VillagepandoAssetRouteImport.update({
            id: '/$asset',path: '/$asset',getParentRoute: () => VillagepandoRoute
          })





const VillagepandoRouteChildren = {
  VillagepandoAssetRoute: VillagepandoAssetRoute
}

const VillagepandoRouteWithChildren = VillagepandoRoute._addFileChildren(VillagepandoRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,VillagepandoRoute: VillagepandoRouteWithChildren,VisionRoute: VisionRoute,WhitepaperRoute: WhitepaperRoute,AdminAnalyticsRoute: AdminAnalyticsRoute,AdminAuditRoute: AdminAuditRoute,AdminFunnelRoute: AdminFunnelRoute,AdminHealthRoute: AdminHealthRoute,AdminMessagesRoute: AdminMessagesRoute,AdminReliabilityRoute: AdminReliabilityRoute,AdminSalesRoute: AdminSalesRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)